import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/react-app/context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string[]; // Opcional: ['ADMIN', 'GESTOR']
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary-600 border-r-transparent"></div>
          <p className="mt-4 text-sm text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar role se especificado
  if (requiredRole && requiredRole.length > 0 && user) {
    if (!requiredRole.includes(user.role)) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
          <div className="bg-white rounded-xl border border-gray-200 p-8 shadow-sm max-w-md w-full text-center">
            <span className="material-symbols-outlined text-red-500 text-5xl mb-4">block</span>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Acesso Negado</h2>
            <p className="text-sm text-slate-600 mb-6">
              Você não tem permissão para acessar esta página.
            </p>
            <a
              href="/funcionarios"
              className="inline-block px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              Voltar ao Início
            </a>
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
}
